import { styled } from '@ringcentral/juno';
import { PrimaryButton } from '@/components/button';
import {
  ctaButtonSizeOnMobile,
  ctaButtonTextOnMobile,
} from '@/components/profileDetail/profileHeader/ctaButton/ctaButton.sc';

export const MnaButton = styled(PrimaryButton)`
  ${ctaButtonSizeOnMobile};

  [class~='MuiButton-label'] {
    ${ctaButtonTextOnMobile};
  }
`;
